var moment = require('moment'); // require
export default function eventDetailSchedule(){

  $('.smx-schedule-block').each( function() {
    const self = $(this);
    const sanction_id = self.attr( 'data-sanction-id' );
    $.ajax({
        method: 'GET',
        url: 'https://data-aws.amaproracing.com/api/event/detail/' + sanction_id,
        dataType: 'json',
        beforeSend: function() {

        },
        complete: function() {

        },
        success: function( events ) {
          let html = '';
          if ( events ) {
            for ( let event of events ) {
              const competitionEvents = event.EventSessions.filter((event) => event.Type !== 'Z');
              for ( let session of competitionEvents ) {
                html += '<div>';
                
                html += '<div class="schedule-date">' + moment( session.SchedStart ).format( 'dddd, MMM D' ) + '</div>';
                html += '<div class="schedule-time">' + moment( session.SchedStart ).format( 'hh:mm a' ) + '</div>';
                html += '<div class="schedule-name">' + session.SessionName + '</div>';
                
                html += '</div>';
              }
            }
          }
        self.find( '.section-content' ).html( html );  
        }
    });    
  });
  
}